import React from 'react'
import PropTypes from 'prop-types'
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
  CartesianGrid,
} from 'recharts'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

const TotemCharts = ({ translate, data, calculateWait, openModalDetails }) => {
  const handleBarClick = (bar) => {
    openModalDetails(bar.createTs)
  }

  const BarTooltip = (active) => {
    if (
      active &&
      active.label &&
      active.payload[0] &&
      active.payload[0].payload
    ) {
      return (
        <div className='totemreports-custom-tooltip'>
          <div className='totemreports-label'>
            {active.payload[0].payload.qnt +
              translate('totem.reports.graph.orders.label')}
          </div>
          <div className='totemreports-label'>
            {calculateWait(active.payload[0].payload.averagePerDay) +
              translate('totem.reports.time.min.abr')}
          </div>
        </div>
      )
    }
    return null
  }

  const getMaxQnt = (data) => {
    const maxValue = parseInt(
      Math.max
        .apply(
          Math,
          data.map((o) => o.qnt)
        )
        .toFixed()
    , 10)
    return roundToCeil(maxValue + maxValue * 0.1)
  }

  const getMaxAverage = (data) => {
    const maxValue = roundToCeil(
      parseInt(
        Math.max
          .apply(
            Math,
            data.map((o) => o.averagePerDay)
          )
          .toFixed()
      , 10)
    )
    return roundToCeil(maxValue + maxValue * 0.1)
  }

  const roundToCeil = (input) => {
    if (input % 10 === 0) return input
    let round = Math.ceil(input)
    while (round % 10 !== 0) round++
    return round
  }

  return (
    <div>
      <Row className='totemreports-row-graph-info'>
        <Col xs={7}>
          <span className='ttotemreports-ime-graph-title'>
            {translate('totem.reports.graph.time.title')}
          </span>
        </Col>
        <Col xs={5}>
          <div className='totemreports-time-graph-legend-icon-above' />
          <span className='totemreports-time-graph-legend-text'>
            {translate('totem.reports.time.options.under')}
          </span>
          <div className='totemreports-time-graph-legend-icon-bellow' />
          <span className='totemreports-time-graph-legend-text'>
            {translate('totem.reports.time.options.above')}
          </span>
        </Col>
      </Row>
      <ResponsiveContainer width='100%' height={300}>
        <BarChart data={data} className='totemreports-barchart'>
          <XAxis dataKey='createTs' stroke='#000000' />
          <YAxis
            dataKey='averagePerDay'
            type='number'
            domain={[0, getMaxAverage(data)]}
            stroke='#000000'
            unit={translate('totem.reports.time.min.abr')}
          />
          <Tooltip  
            content={<BarTooltip />}
            cursor={{ fill: 'transparent' }}
            position={{ y: 20 }}
            isAnimationActive={false} 
          />
          <CartesianGrid vertical={false} stroke='#979797' />
          <ReferenceLine y={5} stroke='#ed1c24' alwaysShow />
          <Bar dataKey='averagePerDay' onClick={handleBarClick} barSize={60}>
            {data.map((entry, index) => (
              <Cell
                cursor='pointer'
                fill={entry.averagePerDay >= 5 ? '#ed1c24' : '#666666'}
                key={`cell-${index}`}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <Row className='totemreports-row-graph-info'>
        <span className='ttotemreports-ime-graph-title'>
          {translate('totem.reports.graph.quantity.title')}
        </span>
      </Row>
      <ResponsiveContainer width='100%' height={300}>
        <BarChart data={data} className='totemreports-barchart'>
          <XAxis dataKey='createTs' stroke='#000000' />
          <YAxis
            dataKey='qnt'
            type='number'
            domain={[0, getMaxQnt(data)]}
            stroke='#000000'
          />
          <Tooltip
            content={<BarTooltip />}
            cursor={{ fill: 'transparent' }}
            position={{ y: 20 }}
            isAnimationActive={false}
          />
          <CartesianGrid vertical={false} stroke='#979797' />
          <Bar dataKey='qnt' fill='#333333' barSize={60} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}

export default TotemCharts

TotemCharts.propTypes = {
  translate: PropTypes.func.isRequired,
  calculateWait: PropTypes.func.isRequired,
  data: PropTypes.object,
  openModalDetails: PropTypes.func,
}
